import { csHttp } from "./http";

export const csAdminUsers = (status) =>
  csHttp.get("/api/admin/users", { params: status ? { status } : {} }).then((r) => r.data);

export const csAdminUserDetail = (id) =>
  csHttp.get(`/api/admin/users/${id}`).then((r) => r.data);

export const csAdminApprove = (id, note) =>
  csHttp.post(`/api/admin/users/${id}/approve`, note ? { note } : {}).then((r) => r.data);

export const csAdminReject = (id, note) =>
  csHttp.post(`/api/admin/users/${id}/reject`, note ? { note } : {}).then((r) => r.data);

export const csAdminActivate = (id) =>
  csHttp.post(`/api/admin/users/${id}/activate`).then((r) => r.data);

export const csAdminDeactivate = (id) =>
  csHttp.post(`/api/admin/users/${id}/deactivate`).then((r) => r.data);

export const csAdminForceAddGroup = (id) =>
  csHttp.post(`/api/admin/users/${id}/force-add-group`).then((r) => r.data);

export const csAdminForceRemoveGroup = (id) =>
  csHttp.post(`/api/admin/users/${id}/force-remove-group`).then((r) => r.data);

export function csAdminAdjustBalance(id, body) {
  return csHttp.post(`/api/admin/users/${id}/adjust-balance`, body);
}
